import React, { useState } from 'react';
import hombre from '../../imagenes/hombre-tomando.png'
import './Auth.css';

const Login = ({ onLoginSuccess, onNavigateToSignUp, onSkipLogin }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  // Credenciales predefinidas
  const predefinedAccount = {
    email: 'dante@cafemoctezuma.com',
    phone: '+541234567890',
    password: 'Dantetiana',
    name: 'Dante Moss'
  };

  const handlePredefinedLogin = () => {
    // Login automático con cuenta predefinida
    const userData = {
      id: 1,
      name: predefinedAccount.name,
      email: predefinedAccount.email,
      phone: predefinedAccount.phone,
      token: 'fake-jwt-token-dante-12345',
      avatar: '🙋🏾‍♂️'
    };

    onLoginSuccess(userData);
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      // Validar si son las credenciales predefinidas
      if (
        (email === predefinedAccount.email || email === predefinedAccount.phone) &&
        password === predefinedAccount.password
      ) {
        // Simular delay para mostrar loading
        await new Promise(resolve => setTimeout(resolve, 800));
        
        const userData = {
          id: 1,
          name: predefinedAccount.name,
          email: predefinedAccount.email,
          phone: predefinedAccount.phone,
          token: 'fake-jwt-token-dante-12345',
          avatar: '🙋🏾‍♂️'
        };

        onLoginSuccess(userData);
        return;
      }

      // Validaciones básicas
      if (!email.trim()) {
        throw new Error('Please enter your email or phone number');
      }
      if (!password.trim()) {
        throw new Error('Please enter your password');
      }

      // Simular llamada a API para otros usuarios
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      // Si no es la cuenta predefinida, mostrar error
      throw new Error('Credenciales inválidas. Trate con: dante@cafemoctezuma.com / Dantetiana');
      
    } catch (err) {
      setError(err.message || 'Login falló. Porfavor intente nuevamente.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="auth-container login-container">
      <div className="auth-header">
        <h2>Bienvenido a <br></br><span className='cursiva'>Café Moctezuma</span></h2>
        <p>Inicie sesión para realizar pedido</p>
        
       
      </div>
      
      {error && (
        <div className="error-message">
          {error}
        </div>
      )}

          <img className='hombre'
          src={hombre}alt='hombre tomando cafe'  
          />

      <form className="auth-form" onSubmit={handleLogin}>
        <div className="input-group">
          <label>Email or phone number</label>
          <input 
            type="text" 
            placeholder="email or phone number" 
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={isLoading}
          />
        </div>
        
        <div className="input-group">
          <label>Password</label>
          <input 
            type="password" 
            placeholder="password" 
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            disabled={isLoading}
          />
        </div>
        
        <div className="remember-forgot">
          <label className="checkbox-label">
            <input 
              type="checkbox" 
              checked={rememberMe}
              onChange={(e) => setRememberMe(e.target.checked)}
              disabled={isLoading}
            />
            <span>Remember me</span>
          </label>
          <button type="button" className="forgot-password">
            Forgot your password?
          </button>
        </div>
        
        <button 
          type="submit" 
          className="auth-btn primary"
          disabled={isLoading}
        >
          {isLoading ? 'Logging in...' : 'Login'}
        </button>
        
        {/*<div className="auth-divider">
          <span>or</span>
        </div>*/}
        
        {/* Botón para login rápido con cuenta predefinida */}
      
        
        <button 
          type="button"
          className="auth-btn secondary"
          onClick={onNavigateToSignUp}
          disabled={isLoading}
        >
          Create an Account
        </button>
         {/* Información de cuenta predefinida */}
        <div className="predefined-account-info">
          <p className="demo-note">Cuenta demo disponible:</p>
          <div className="account-details">
            <p><strong>Email:</strong> {predefinedAccount.email}</p>
            <p><strong>Password:</strong> {predefinedAccount.password}</p>
          </div>
        </div>

          <button 
          type="button"
          className="auth-btn predefined"
          onClick={handlePredefinedLogin}
          disabled={isLoading}
        >
          Login con cuenta Dante
        </button>

        <button 
          type="button"
          className="auth-btn demo"
          onClick={onSkipLogin}
          disabled={isLoading}
        >
          Detener acceso a demo (No Login)
        </button>
      </form>
    </div>
  );
};

export default Login;




/*import React, { useState } from 'react';
import './Auth.css';

const Login = ({ onLoginSuccess, onNavigateToSignUp, onSkipLogin }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      // Validaciones básicas
      if (!email.trim()) {
        throw new Error('Please enter your email or phone number');
      }
      if (!password.trim()) {
        throw new Error('Please enter your password');
      }

      // Simular llamada a API
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      // Datos del usuario simulado
      const userData = {
        id: 1,
        name: 'Dante Moss',
        email: email,
        phone: '+1234567890',
        token: 'fake-jwt-token-12345'
      };

      onLoginSuccess(userData);
      
    } catch (err) {
      setError(err.message || 'Login failed. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleDemoLogin = () => {
    // Acceso rápido para demo
    onLoginSuccess({
      id: 1,
      name: 'Demo User',
      email: 'demo@cafemoctezuma.com',
      phone: '+1234567890',
      token: 'demo-token'
    });
  };

  return (
    <div className="auth-container login-container">
      <div className="auth-header">
        <h2>Welcome to Cafe Motezuma</h2>
        <p>Login to continue ordering</p>
      </div>
      
      {error && (
        <div className="error-message">
          {error}
        </div>
      )}

      <form className="auth-form" onSubmit={handleLogin}>
        <div className="input-group">
          <label>Email or Phone Number</label>
          <input 
            type="text" 
            placeholder="Enter your email or phone" 
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={isLoading}
          />
        </div>
        
        <div className="input-group">
          <label>Password</label>
          <input 
            type="password" 
            placeholder="Enter your password" 
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            disabled={isLoading}
          />
        </div>
        
        <div className="remember-forgot">
          <label className="checkbox-label">
            <input 
              type="checkbox" 
              checked={rememberMe}
              onChange={(e) => setRememberMe(e.target.checked)}
              disabled={isLoading}
            />
            <span>Remember me</span>
          </label>
          <button type="button" className="forgot-password">
            Forgot Password?
          </button>
        </div>
        
        <button 
          type="submit" 
          className="auth-btn primary"
          disabled={isLoading}
        >
          {isLoading ? 'Logging in...' : 'Login'}
        </button>
        
        <div className="auth-divider">
          <span>or</span>
        </div>
        
        <button 
          type="button"
          className="auth-btn secondary"
          onClick={onNavigateToSignUp}
          disabled={isLoading}
        >
          Create New Account
        </button>

        <button 
          type="button"
          className="auth-btn demo"
          onClick={handleDemoLogin}
          disabled={isLoading}
        >
          Quick Demo Access
        </button>
      </form>
    </div>
  );
};

export default Login;*/